import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CheckCircle2 } from 'lucide-react';

function SuccessPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white px-4 text-center">
      <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mb-6">
        <CheckCircle2 className="w-12 h-12 text-green-600" />
      </div>
      <h1 className="text-4xl font-black text-gray-900">Action Successful</h1>
      <p className="mt-4 text-lg text-gray-600 max-w-md">
        Your request has been processed successfully. Thank you for your participation!
      </p>
      <div className="mt-10 flex gap-4">
        <Button 
          variant="outline"
          onClick={() => navigate('/')}
          className="border-2 border-QWA2_TALENT_SHOW-gold text-QWA2_TALENT_SHOW-gold hover:bg-QWA2_TALENT_SHOW-gold hover:text-white rounded-xl"
        >
          Go Home
        </Button>
        <Button 
          onClick={() => navigate('/competitions')}
          className="bg-black text-white hover:bg-gray-900 rounded-xl"
        >
          View Competitions
        </Button>
      </div>
    </div>
  );
}

export default SuccessPage;